export default (pollId) =>
  $.ajax({
    url: `/polls/${pollId}/group_activities`,
    dataType: 'json',
    type: 'POST',
    data: {},
  });
